import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_INGREDIENT_MUTATION } from '../graphql/mutations'
import { DELETE_INGREDIENT } from '../redux/action-types'

const useDeleteIngredientMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredients,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_INGREDIENT_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_INGREDIENT,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteIngredientMutation
